// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1937":"5fc3748168a85441","2167":"f7964ee40f9dd60c"}[chunkId] + ".css";
};